import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import { UserAnalyticsByDaysModel } from "../models/UserAnalyticsByDaysModel";
import { UserActivityHistoryModel } from "../models/UserActivityHistoryModel";

export interface GetUserAnalyticsByDaysParam {
    userId: number,
    day: number
}

export interface GetUserActivityDetailsParam {
    year: number,
    month: number,
    day: number,
    userId: number,
    userActivityType: string
}

export enum UserActivityType {
    Input = "Input",
    Search = "Search"
}

const UserAnalyticsApi = {
    GetUserAnalyticsByDays(param: GetUserAnalyticsByDaysParam) {
        return Api.get<GetUserAnalyticsByDaysParam, BaseResponse<UserAnalyticsByDaysModel[]>>("/api/UserAnalytics/GetUserAnalyticsByDays", param);
    },
    GetUserActivityDetails(param: GetUserActivityDetailsParam) {
        return Api.get<GetUserActivityDetailsParam, BaseResponse<UserActivityHistoryModel[]>>("/api/UserAnalytics/GetUserActivityDetails", param);
    },
};
export default UserAnalyticsApi;